import * as zod from 'zod';

/**
 * One operator estimate of how long a task took with the agent versus how
 * long it would have taken by hand. Logged from the clock beside a reply's
 * thumbs, so it hangs off the assistant message that finished the task; at
 * most one per message. agent-bot forwards each row to that turn's
 * Braintrust span so the triage report can compute time saved per step.
 */
export const AgentTaskTimingData = zod.object({
  id: zod.string(),
  sessionID: zod.string(),
  messageID: zod.string(),
  /** What the operator was doing, in their words. */
  taskName: zod.string().nullable(),
  minutesByHand: zod.number().int().positive(),
  minutesWithAgent: zod.number().int().positive(),
  createdAt: zod.string(),
});

export type AgentTaskTimingData = zod.infer<typeof AgentTaskTimingData>;

export const AgentTaskTimingCreateInput = zod.object({
  sessionID: zod.string(),
  messageID: zod.string(),
  taskName: zod.string().trim().max(200).nullable().optional(),
  minutesByHand: zod
    .number()
    .int()
    .positive()
    .max(24 * 60),
  minutesWithAgent: zod
    .number()
    .int()
    .positive()
    .max(24 * 60),
});

export type AgentTaskTimingCreateInput = zod.infer<
  typeof AgentTaskTimingCreateInput
>;
